<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <form action="post" @submit.prevent="saveContact" :class="{ 'was-validated': submitted }">
      <div class="form-group">
        <label for="Firstname">Förnamn</label>
        <input type="text" class="form-control" id="Firstname" v-model="contact.Firstname" required>
      </div>

      <div class="form-group">
        <label for="Lastname">Efternamn</label>
        <input type="text" class="form-control" id="Lastname" v-model="contact.Lastname" required>
      </div>

      <div class="form-group">
        <label for="Position">Position</label>
        <input type="text" class="form-control" id="Position" v-model="contact.Position">
      </div>

      <div class="form-group">
        <label for="Phone">Telefon</label>
        <select class="form-control" v-model="contact.Phone">
          <option></option>
          <option v-for="(p, index) in olContact.phones" :key="index">{{ p.number }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="Mobile">Mobil</label>
        <select class="form-control" v-model="contact.Mobile">
          <option></option>
          <option v-for="(p, index) in olContact.phones" :key="index">{{ p.number }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="Email">Epost</label>
        <select class="form-control" v-model="contact.Email">
          <option></option>
          <option v-for="(p, index) in olContact.emailAddresses" :key="index">{{ p.address }}</option>
        </select>
      </div>

      <button type="button" class="btn btn-link" @click="$router.push({ name: 'customer', params: { id: custId }})">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['custId', 'id'],

  data () {
    return {
      submitted: false,
      olContact: {},
      contact: {
        CustomerId: this.custId,
        Firstname: '',
        Lastname: '',
        Position: '',
        Phone: '',
        Mobile: '',
        Email: ''
      },
      error: ''
    }
  },
  created () {
    appService.getOutlookContact(this.id)
    .then(result => {
      this.olContact = result

      this.contact.Firstname = this.olContact.givenName
      this.contact.Lastname = this.olContact.surname
      this.contact.Position = this.olContact.jobTitle

      const businessPhone = this.olContact.phones.find((phone) => {
        return phone.type === 'business'
      })
      this.contact.Phone = businessPhone ? businessPhone.number : ''

      const mobilePhone = this.olContact.phones.find((phone) => {
        return phone.type === 'mobile'
      })
      this.contact.Mobile = mobilePhone ? mobilePhone.number : ''
      this.contact.Email = this.olContact.emailAddresses.length > 0 ? this.olContact.emailAddresses[0].address : ''
    })
  },

  methods: {
    saveContact () {
      appService.createContact(this.contact).then(() => {
        this.$router.push({ name: 'customer', params: { id: this.custId }})
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/OutlookContactAdd.vue